'use client';

import React, { useLayoutEffect, useRef } from 'react';
import { usePathname } from 'next/navigation';

interface PageTransitionProps {
  children: React.ReactNode;
  className?: string;
}

const PageTransition: React.FC<PageTransitionProps> = ({ children, className }) => {
  const pathname = usePathname();
  const isFirstRender = useRef(true);

  useLayoutEffect(() => {
    // Skip the first render so SSR/hydration content stays visible
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    const el = document.getElementById('page-content');
    if (!el) return;

    // Hide immediately (runs before browser paint — no flash)
    el.style.opacity = '0';
    el.style.transition = 'none';

    // After paint, fade in
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        el.style.transition = 'opacity 200ms ease-out';
        el.style.opacity = '1';
      });
    });
  }, [pathname]);

  return (
    <div className={className} id="page-content">
      {children}
    </div>
  );
};

export default PageTransition;
